import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components/Button'
import Icon from '@/components/Icon'

import useCheckout from '../../hooks/useCheckout'
import Step from '../Step/Step'
import { ConfirmationContent, ConfirmationFooter, ConfirmationIcon, ConfirmationVendor } from './Confirmation.styles'
import ConfirmationReceiptModal from './ConfirmationReceiptModal'

const Confirmation = () => {
  const { t } = useTranslation()
  const { cart, paymentError } = useCheckout()
  const [isReceiptLoading, setIsReceiptLoading] = useState(false)
  const [onlineReceipt, setOnlineReceipt] = useState(null)
  const [isPrintLoading, setIsPrintLoading] = useState(false)

  const printConfirmation = () => {
    setIsPrintLoading(true)
    setTimeout(() => {
      setIsPrintLoading(false)
    }, 2000)
  }

  const showOnlineRceipt = () => {
    setIsReceiptLoading(true)
    setTimeout(() => {
      setIsReceiptLoading(false)
      setOnlineReceipt('iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQAAAABRBrPYAAACQElEQVR4Xu2XQY7bMAxF6ZWPoZta8k1zhC69kvrfl6edUQu0m6IIYcIwaPI5QD4pMonxN/Yt1shv7cEWe7DFHmyxB1vswRb7F1gPrF5FTh2vesmP2F9E91wY/uvYRyP+06l3KhP2IkvK4vgtKaPIkRGrV2zIYj81RkS9HVEVukqzROkw3RQs5xhcVxk40mSmEmHIoO9O3T9fRHNh03qUTquXk7qPZmBaGqxT9Nc8y/Wuvlqdzt9yYcMKqM83Zw9LYXFi+mkwRTYiAPgDoJK5X8mDRdFdmqi9XfcyrtL3H0IlwnbvnYj6BaDh8RNhbm+y3fuoBXXvEVs+7JIO2jtMqtne57AaDO18mCO6B36TGpcu9EmHaXCp6MXPzCvIr4MrAdbtd8/n8PjqFF0Mj6mwYEwdXMPK8FO5M8rWSf72GFkUqN5EzW/ha6CRz4MNRvTcRIggEtj68AmZMIKKEJfT6HAeq894JqyTVWOjxrAaDlL3lguTIULIkAKMnr9TybDTS3b6E2hB2y+CvD82d5BaWudaKbWBNFnXbgKsfzCBCOhwDs7y9stxfndsqKXd3gPGPeAmPwdXJqx/FFoNIP90xTndO8s3EzbNcSbY6T6fr/TPpX9/DMCbqEsBt8Hwf73DWzgVhg9w+pUjOMUdQZAoF6ZCz9/GOs5lRg4z/oRs2GFZSBmQNeIJsToAqs5ylD67PSGmG7XevGc1uDy7SE3LgwXm0rN5I9Ck0QM3nAb7oz3YYg+22IMt9mCLPdhi/wf7DpcVjSOTO3NZAAAAAElFTkSuQmCC')
    }, 2000)
  }

  return (
    <Step>
      <ConfirmationContent>
        {/* Success */}
        {!paymentError && (
          <>
            <ConfirmationIcon>
              <svg viewBox="0 0 188 142">
                <motion.polyline
                  strokeWidth="30"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transition={{
                    delay: 0,
                    duration: 0.75
                  }}
                  fill="none"
                  points="20 74 73 126 170 20"
                ></motion.polyline>
              </svg>
            </ConfirmationIcon>
            <h1>{t('paymentConfirmationTitle')}</h1>
            <p>{t('paymentConfirmationDescription')}</p>
          </>
        )}
        {/* Error */}
        {paymentError && (
          <>
            <ConfirmationIcon>
              <svg viewBox="0 0 138 138">
                <g stroke="#E43232" strokeWidth="23">
                  <motion.line
                    x1="13"
                    y1="125"
                    x2="125"
                    y2="13"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transition={{
                      delay: 0,
                      duration: 0.75
                    }}
                  ></motion.line>
                  <motion.line
                    x1="13"
                    y1="13"
                    x2="125"
                    y2="125"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{
                      delay: 0.25,
                      duration: 0.75
                    }}
                  ></motion.line>
                </g>
              </svg>
            </ConfirmationIcon>
            <h1>{t('paymentErrorTitle')}</h1>
            <p>{paymentError}</p>
          </>
        )}
      </ConfirmationContent>
      <ConfirmationFooter>
        <ConfirmationVendor>
          <span>Powered by</span>
          <Icon name="berg" />
        </ConfirmationVendor>
        {!paymentError && (
          <>
            <Button block={true} variant="secondary" isLoading={isPrintLoading} onClick={() => printConfirmation()}>
              {t('printConfirmation')}
            </Button>
            <Button
              block={true}
              variant="secondary"
              isLoading={isReceiptLoading}
              transparent
              icon="qr-code"
              onClick={() => showOnlineRceipt()}
            >
              {t('showOnlineRceipt')}
            </Button>
          </>
        )}
      </ConfirmationFooter>
      <AnimatePresence>
        {onlineReceipt && <ConfirmationReceiptModal image={onlineReceipt} onClose={() => setOnlineReceipt(null)} />}
      </AnimatePresence>
    </Step>
  )
}

export default Confirmation
